import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import MyContext from "../../../MyContext";
const keypadFull = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["0", "Clear", "⌫"],
];
const Items = ({ tabletMode, mobile, setMobile, customerList, orderId, userID, handleAddCart, catalogueStore, setCatalogueStore, itemSearchRef, newmobileRef, onFocusMobile, onFocus, getCustomerApi, selectedCustomer, orderType, editCustomer, setEditCustomer, searchCustomerLoader, setSelectedCustomer }) => {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [selectedCatagory, setSelectedCatagory] = useState([]);
  const [selectedCatagoryInfo, setSelectedCatagoryInfo] = useState({});
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [categoryPage, setCategoryPage] = useState(0);
  const [itemPage, setItemPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const CATEGORIES_PER_PAGE = 9;
  const ITEMS_PER_PAGE = 10;
  // const[mobile,setMobile]=useState("");
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [showTableModal, setShowTableModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showAddressFormFor, setShowAddressFormFor] = useState(null);
  const [editingName, setEditingName] = useState(false);
  const [newName, setNewName] = useState("");

  const [formErrors, setFormErrors] = useState({});
  const [newAddress, setNewAddress] = useState({
    landmark_area: "",
    address: "",
    city: "",
    name: "",
  });
  const formErrorsOrder = [
    "name",
    "address",
    "city",
    "mobile",
  ];
  const handleKeyClick = (key) => {
    if (key === "Clear") setMobile("");
    else if (key === "⌫") setMobile((prev) => prev.slice(0, -1));
    else if (/^\d$/.test(key) && mobile.length < 10)
      setMobile((prev) => prev + key);
  };
  const handleInputChange = (field, value) => {
    setNewAddress((prev) => ({ ...prev, [field]: value }));

    // Only clear the error if the current field has the top-level error
    if (formErrorsOrder[0] === field) {
      setFormErrors((prev) => {
        const updated = { ...prev };
        delete updated[field];
        return updated;
      });
    }
  };
  const handleAddMoreAddress = async (customer) => {
    const errors = {};

    // Basic required field validations
    if (!newAddress.address.trim()) {
      errors.address = "Full Address is required.";
    } else if (!newAddress.landmark_area.trim()) {
      errors.landmark_area = "Landmark / Area is required.";
    } else if (!newAddress.city.trim()) {
      errors.city = "City is required.";
    }



    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    // Proceed to send to backend
    const payload = {
      userid: userID,
      custName: customer.contact_name,
      custMobile: mobile,
      address: {
        address: newAddress.address,
        landmark_area: newAddress.landmark_area,
        city: newAddress.city,
      },
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/addDeliveryAddress`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setShowAddressFormFor(null);
        setNewAddress({
          address: "",
          landmark_area: "",
          city: "",
        });
        setFormErrors({});
        getCustomerApi();
      } else {
        setFormErrors({ api: data.responseMessage });
      }
    } catch (err) {
      setFormErrors({ api: "Failed to add address. Please try again." });
    }
  };
  const handleAddNewAddress = async (customer) => {
    const errors = validateFields(customer, newAddress);

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    const payload = {
      userid: userID,
      custName: customer.contact_name,
      custMobile: customer.contact_number,
      address: {
        address: newAddress.address,
        landmark_area: newAddress.landmark_area,
        city: newAddress.city,
      },
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/addDeliveryAddress`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setShowAddressFormFor(null);
        setNewAddress({
          name: "",
          address: "",
          landmark_area: "",
          city: "",
          // ...reset other fields
        });
        getCustomerApi();
        setFormErrors({});
      } else {
        setFormErrors({ api: data.responseMessage });
      }
    } catch (err) {
      setFormErrors({ api: "Failed to add address. Please try again." });
    }
  };
  const handleDefaultAddress = async (contact_number, address) => {
    //    if (mobile.length !== 10 || mobile.length !== 12) {
    // return;
    //    }
    const payload = {
      userid: userID,
      address: address,
      custMobile: contact_number,
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/setDefaultDeliveryAddress`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        getCustomerApi();
      } else {
        // alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      // alert("Failed to add address");
      console.error("API error:", error);
    }
  };
  const validateFields = (customer) => {
    const errors = {};
    if (!newAddress.name.trim()) errors.name = "Name is required.";
    else if (!newAddress.address.trim())
      errors.address = "Address is required.";
    else if (!newAddress.landmark_area.trim())
      errors.landmark_area = "Landmark / Area is required.";
    else if (!newAddress.city.trim()) errors.city = "City is required.";
    else if (
      !customer?.contact_number ||
      !/^\d{10,12}$/.test(customer.contact_number)
    ) {
      errors.mobile = "Enter a valid mobile number (10 or 12 digits).";
    }

    return errors;
  };



  const handleUpdateCustomerName = async (newName, mobNumber) => {
    if (!newName) {
      return;
    }
    const payload = {
      userid: userID,
      custMobile: mobNumber,
      custName: newName,
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCustomerName`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setNewName("");
        setEditingName(false);
        setEditCustomer(false);

      } else {
        // alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      // alert("Failed to add address");
      console.error("API error:", error);
    }
  };






  useEffect(() => {
    if (catalogueStore && catalogueStore.length > 0) {
      const firstCatId = String(catalogueStore[0].cat_id);
      setExpandedCategories([firstCatId]);
      setSelectedCatagory(catalogueStore[0].menu_items || []);
      setSelectedCatagoryInfo(catalogueStore[0]);
    }
  }, [catalogueStore]);
  const toggleCategory = (catId) => {
    setExpandedCategories((prev) =>
      prev.includes(catId)
        ? prev.filter((id) => id !== catId)
        : [...prev, catId]
    );
  };
  const filteredCategories = useMemo(() => {
    if (!catalogueStore) return [];
    return catalogueStore
      .map((category) => {
        const filteredItems = (category.menu_items || []).filter((item) =>
          item?.item_name?.toLowerCase().includes(searchText.toLowerCase())
        );
        return {
          ...category,
          menu_items: filteredItems,
        };
      })
      .filter((category) => category.menu_items.length > 0);
  }, [catalogueStore, searchText]);
  useEffect(() => {
    if (searchText.trim()) {
      const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
      setExpandedCategories(matchedIds);
    } else {
      const firstCatId = String(catalogueStore?.[0]?.cat_id || "");
      setExpandedCategories(firstCatId ? [firstCatId] : []);
    }
  }, [filteredCategories, searchText, catalogueStore]);

  const paginatedCategories = catalogueStore.slice(
    categoryPage * CATEGORIES_PER_PAGE,
    (categoryPage + 1) * CATEGORIES_PER_PAGE
  );
  const paginatedFilteredItems = filteredCategories.slice(
    itemPage * ITEMS_PER_PAGE,
    (itemPage + 1) * ITEMS_PER_PAGE
  );
  const paginatedItems = selectedCatagory.slice(
    itemPage * ITEMS_PER_PAGE,
    (itemPage + 1) * ITEMS_PER_PAGE
  );
  const handleNextCategoryPage = () => {
    if ((categoryPage + 1) * CATEGORIES_PER_PAGE < filteredCategories.length) {
      setCategoryPage(categoryPage + 1);
    }
  };
  const handlePrevCategoryPage = () => {
    if (categoryPage > 0) setCategoryPage(categoryPage - 1);
  };
  const handleNextItemPage = () => {
    if ((itemPage + 1) * ITEMS_PER_PAGE < selectedCatagory.length) {
      setItemPage(itemPage + 1);
    }
  };
  const handlePrevItemPage = () => {
    if (itemPage > 0) setItemPage(itemPage - 1);
  };
  const [filteredPage, setFilteredPage] = useState(0);
  const ITEMS_PER_PAGE_FILTER = 6; // or any number per page
  const paginatedFilteredCategories = (() => {
    const flatItems = [];

    // Flatten items with category info
    for (const category of filteredCategories) {
      for (const item of category.menu_items) {
        flatItems.push({
          ...item,
          category_name: category.category_name,
          cat_id: category.cat_id,
        });
      }
    }

    // Apply pagination on the flat array
    const start = filteredPage * ITEMS_PER_PAGE_FILTER;
    const end = start + ITEMS_PER_PAGE_FILTER;
    const paginatedItems = flatItems.slice(start, end);

    // Group paginated items back into categories
    const grouped = {};
    for (const item of paginatedItems) {
      if (!grouped[item.cat_id]) {
        grouped[item.cat_id] = {
          category_name: item.category_name,
          cat_id: item.cat_id,
          menu_items: [],
        };
      }
      grouped[item.cat_id].menu_items.push(item);
    }

    return Object.values(grouped);
  })();


  const changeCustomerAPI = async () => {

    const payload = {
      userid: userID,
      orderId: orderId,
      custMobile: mobile,
      custName: "",
      platform: "POS"


    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/Order/changeCustomer`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setEditCustomer(false);
      } else {
        setFormErrors({ api: data.responseMessage });
      }
    } catch (err) {
      setFormErrors({ api: "Failed to add address. Please try again." });
    }
  };

  return (
    <div className="row p-0 m-0 h-100">
      {/* Items Section */}
      <div className="col-9 p-2 m-0   border-start border-dark h-100" >
        <div className="d-flex flex-column justify-content-between h-100">
          <div>
            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom border-dark">
              <h4 className="fw-semibold m-0" >
                {searchText ? "Search Results" : selectedCatagoryInfo.category_name}
              </h4>

              <div className="d-flex align-items-center gap-2">
                <input
                  type="text"
                  className="form-control form-control-sm p-2 border-dark rounded"
                  style={{ minWidth: "300px" }}
                  placeholder="Search item..."
                  value={searchText}
                  onChange={(e) => { setSearchText(e.target.value); }}
                onFocus={onFocus}
                />
                {searchText && (
                  <button
                    className="btn btn-sm p-2 btn-outline-danger"
                    onClick={() => setSearchText("")}
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
            <div className="row px-2">
              {searchText ?
                <>
                  {/* {JSON.stringify(filteredCategories)} */}
                  {paginatedFilteredCategories.length > 0 ?
                    <>
                      {paginatedFilteredCategories.map((category) => {
                        const catId = String(category.cat_id);
                        return (
                          <div key={catId} className="mb-2">
                            <div className="d-flex flex-column justify-content-between align-items-center p-3 ">
                              <h5 className="text-center p-0 m-0 mb-3 fw-bold">{category.category_name}</h5>
                              <div className="row col-12  m-0  px-2">
                                {category.menu_items.map((item, index) => (
                                  <div className="col-3 mb-3" key={index}>
                                    <div
                                      className="d-flex align-items-center bg-pos-card text-center rounded shadow-sm p-3 h-100 hover-shadow"
                                      role="button"
                                      style={{ border: "1px solid #000" }}
                                      onClick={() => {
                                        if (item.prices.length === 1) {
                                          handleAddCart(item, item.prices[0]);
                                        }
                                      }}
                                    >
                                      <div className="flex-grow-1 w-100">
                                        <h5 className="mb-2 text-dark fw-bold">{item.item_name}</h5>

                                        {item.prices.length > 1 ? (
                                          <div
                                            className="d-flex flex-wrap gap-2 justify-content-center mt-2"
                                            style={{ zIndex: 2 }}
                                          >
                                            {item.prices.map((price) => {
                                              const itemWithSelectedPriceOnly = {
                                                ...item,
                                                prices: [price]
                                              };

                                              // Assign color class based on size
                                              let colorClass = '';
                                              switch (price.size.toLowerCase()) {
                                                case 'qtr.':
                                                  colorClass = 'bg-warning-subtle text-dark';
                                                  break;
                                                case 'half':
                                                  colorClass = 'bg-info-subtle text-dark';
                                                  break;
                                                case 'full':
                                                  colorClass = 'bg-success-subtle text-dark';
                                                  break;
                                                default:
                                                  colorClass = 'bg-light text-dark';
                                              }

                                              return (
                                                <button
                                                  key={`${item.item_id}-${price.size_id}-${price.price}`}
                                                  onClick={(e) => {
                                                    e.stopPropagation(); // Prevent card click
                                                    handleAddCart(itemWithSelectedPriceOnly, price);
                                                  }}
                                                  className={`btn btn-sm ${colorClass} shadow-sm rounded px-2 fw-semibold`}
                                                  style={{ minWidth: "80px", fontSize: "1.2rem" }}
                                                >
                                                  {price.formatted_price}
                                                  {/* Optionally show size: ({price.size}) */}
                                                </button>
                                              );
                                            })}
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                  // <div className="col-4 p-2 m-0 " key={index}>
                                  //   <div
                                  //     className="d-flex align-items-center bg-pos-card text-center rounded shadow-sm p-3 h-100  hover-shadow"
                                  //     role="button"
                                  //     style={{ border: "1px solid #000" }}
                                  //     onClick={() => handleAddCart(item)}
                                  //   >
                                  //     <div className="flex-grow-1">
                                  //       <h5 className="mb-2 text-dark font-bold p-0 m-0">{item.item_name}</h5>
                                  //       {item.prices.length > 1 && (
                                  //         <div className="text-muted d-flex flex-column gap-3">
                                  //           {item.prices.map(p => (
                                  //             <div key={p.size_id}>
                                  //               <button className="btn border-dark text-dark w-100">
                                  //                 {p.formatted_price}
                                  //               </button>
                                  //             </div>
                                  //           ))}
                                  //         </div>
                                  //       )}
                                  //     </div>
                                  //   </div>
                                  // </div>

                                ))}
                              </div>
                              <hr />
                            </div>
                          </div>
                        );
                      })}
                    </>
                    :
                    <h4 className="text-danger text-center mt-5" >No Item Found for <span className="text-dark">"{searchText}"</span></h4>
                  }


                </>
                :
                <>
                  {/* {paginatedItems.map((item, index) => ( */}


                  <div className="row col-12 p-0 m-0" style={{
                    maxHeight: "calc(100vh - 200px)",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}>
                    {selectedCatagory.map((item) => (
                      <div className="col-2 p-0 m-0 p-1" key={item.item_id}>
                        <div
                          className="d-flex flex-column align-items-center bg-pos-card text-center rounded shadow-sm  h-100 hover-shadow"
                          role="button"
                          onClick={() => {
                            if (item.prices.length === 1) {
                              handleAddCart(item, item.prices[0]);
                            }
                          }}
                          key={item.item_id}
                        >
                          <div className="p-0 py-2">
                            <h6 className=" text-dark fw-bold p-2 m-0">{item.item_name}</h6>

                            {item.prices.length > 1 ? (
                              <div
                                className="d-flex flex-wrap justify-content-center gap-1"
                                style={{ zIndex: 2 }}
                              >
                                {item.prices.map((price) => {
                                  const itemWithSelectedPriceOnly = {
                                    ...item,
                                    prices: [price]
                                  };

                                  // Assign color class based on size
                                  let colorClass = '';
                                  switch (price.size.toLowerCase()) {
                                    case 'qtr.':
                                      colorClass = 'bg-warning-subtle text-dark';
                                      break;
                                    case 'half':
                                      colorClass = 'bg-info-subtle text-dark';
                                      break;
                                    case 'full':
                                      colorClass = 'bg-success-subtle text-dark';
                                      break;
                                    default:
                                      colorClass = 'bg-light text-dark';
                                  }

                                  return (
                                    <button
                                      key={`${item.item_id}-${price.size_id}-${price.price}`}
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent card click
                                        handleAddCart(itemWithSelectedPriceOnly, price);
                                      }}
                                      className={`btn btn-sm ${colorClass} shadow-sm rounded px-2 fw-semibold`}

                                    >
                                      <p className="p-0 m-0 fs-small">{price.formatted_price}</p>
                                      {/* Optionally show size: ({price.size}) */}
                                    </button>
                                  );
                                })}
                              </div>
                            ) : null}
                          </div>

                        </div>
                      </div>
                    ))} </div>
                </>
              }


            </div>
          </div>
          {searchText ?
            <div className=" d-flex justify-content-between align-items-center gap-2 mt-3">
              <button
                className="scale-button btn btn-sm btn-outline-dark text-center py-2 m-0 w-25"
                onClick={() => setFilteredPage(prev => Math.max(prev - 1, 0))}
                disabled={filteredPage === 0}
              >
                <h5 className="m-0">Prev</h5>
              </button>

              <div className="text-center ">
                <h6 className="m-0">
                  Page {filteredPage + 1} / {Math.ceil(
                    filteredCategories.reduce(
                      (acc, category) => acc + category.menu_items.length,
                      0
                    ) / ITEMS_PER_PAGE_FILTER
                  )}
                </h6>
              </div>

              <button
                className="scale-button btn btn-sm btn-outline-dark text-center py-2 m-0 w-25"
                onClick={() => setFilteredPage(prev => prev + 1)}
                disabled={
                  (filteredPage + 1) * ITEMS_PER_PAGE_FILTER >=
                  filteredCategories.reduce((acc, category) => acc + category.menu_items.length, 0)
                }
              >
                <h5 className="m-0">Next</h5>
              </button>
            </div>

            :
            null
            //        <div className="d-flex justify-content-between align-items-center gap-2 mt-3">
            //   <button
            //     className="btn btn-sm btn-outline-dark text-center py-2 m-0 w-25"
            //     onClick={handlePrevItemPage}
            //     disabled={itemPage === 0}
            //   >
            //     <h5 className="d-flex align-items-center justify-content-center p-0 m-0">Prev</h5>
            //   </button>

            //   <div className="text-center w-50">
            //     <h6 className="m-0">
            //       Page {itemPage + 1} / {Math.ceil(selectedCatagory.length / ITEMS_PER_PAGE)}
            //     </h6>
            //   </div>

            //   <button
            //     className="btn btn-sm btn-outline-dark text-center py-2 m-0 w-25"
            //     onClick={handleNextItemPage}
            //     disabled={(itemPage + 1) * ITEMS_PER_PAGE >= selectedCatagory.length}
            //   >
            //     <h5 className="d-flex align-items-center justify-content-center p-0 m-0">Next</h5>
            //   </button>
            // </div>
          }

        </div>




      </div>

      {/* Category Section */}
      {/* Category Section */}
      <div className="col-3 p-2 m-0  border-start border-dark d-flex flex-column h-100 " style={{ height: '100%' }}>
        <div className="d-flex flex-column justify-content-between h-100 p-0 m-0">
          <div className=" p-0 m-0">
            <h4 className="text-center py-2 text-dark mb-4" style={{ borderBottom: "1px solid #111" }}>
              Category
            </h4>
            <div className="d-flex flex-column justify-content-between flex-grow-1">
              {/* Category List */}
              <div style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
                overflowX: "hidden",
              }} className="px-2">

                {/* {paginatedCategories.map((category, index) => { */}
                {catalogueStore.map((category, index) => {
                  const catId = String(category.cat_id);
                  return (
                    <div key={catId} className="mb-2">
                      <div
                        className={`${selectedCatagoryInfo.cat_id === category.cat_id
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"
                          } scale-button  d-flex justify-content-between align-items-center rounded shadow-sm p-3`}
                        role="button"
                        style={{ border: "1px solid #ccc" }}
                        onClick={() => {
                          toggleCategory(catId);
                          setSelectedCatagory(category.menu_items);
                          setSelectedCatagoryInfo(category);
                          setItemPage(0);
                        }}
                      >
                        <span className="fw-bold">
                          {category.category_name?.length > 20
                            ? category.category_name.slice(0, 15)
                            : category.category_name}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>


            </div>

          </div>

          {/* <div className="d-flex justify-content-between  align-items-center   gap-2">
      <button
        className="btn btn-sm btn-outline-dark text-center py-2 m-0  w-50"
        onClick={handlePrevCategoryPage}
        disabled={categoryPage === 0}
      >
       <h5 className="d-flex align-items-center justify-content-center p-0 m-0">Prev</h5> 
      </button>
      <button
        className="btn btn-sm btn-outline-dark text-center py-2 m-0  w-50"
        onClick={handleNextCategoryPage}
        disabled={(categoryPage + 1) * CATEGORIES_PER_PAGE >= filteredCategories.length}
      >
          <h5 className="d-flex align-items-center justify-content-center p-0 m-0">Next</h5> 
        
      </button>
    </div> */}
        </div>



      </div>
      {editCustomer && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ backgroundColor: "#00000088", zIndex: 1040 }}
            onClick={() => setShowMobileModal(false)}
          />
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white border shadow p-4 rounded"
            style={{ width: "1200px", zIndex: 1050 }}
          >
            {/* {JSON.stringify(selectedTable)} */}
            <div className="row col-12 p-0 m-0">
              {/* {JSON.stringify(selectedCustomer)} */}
              <div className="col-5">
                <h3 className="text-center mb-3 fw-bold">
                  Enter Mobile Number
                </h3>
                {/* {JSON.stringify(selectedTable.tableNo)} */}
                <input
                  type="text"
                  inputMode="numeric"
                  className="form-control shadow form-control-lg text-center fw-bold mb-3 p-3 border border-dark"
                  value={mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 12) setMobile(value);
                  }}
                  placeholder="10-digit mobile"
                  onFocus={onFocusMobile}
                />
                <div className="row mb-3">
                  {keypadFull.map((row, i) => (
                    <div className="row w-100 m-0 p-0" key={i}>
                      {row.map((key) => (
                        <div className="col-4 " key={key}>
                          <button
                            type="button"
                            tabIndex={-1}
                            onClick={() => handleKeyClick(key)}
                            style={{ height: "80px", width: "100%" }}
                            className="scale-button shadow border  my-3 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
                          >
                            {key}
                          </button>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <button
                    className="scale-button btn btn-light fs-4 fw-bold  border border-dark"
                    style={{ height: "80px", width: "25%" }}
                    tabIndex={-1}
                    onClick={() => {
                      setEditCustomer(false);
                    }}
                  >
                    Close
                  </button>

                  <button
                    type="button"
                    onClick={() => { changeCustomerAPI() }}
                    disabled={
                      !(
                        orderType === "dining" ||
                        orderType === "room_order" ||
                        mobile.length === 10 ||
                        mobile.length === 12
                      )
                    }
                    style={{ height: "80px", width: "75%" }}
                    className={`scale-button shadow border border-dark btn btn-success bg-green-order rounded  d-flex justify-content-center align-items-center fs-4 fw-bold
                       `}
                  >
                    Continue
                  </button>
                </div>
              </div>
              <div className="col-7">
                <div
                  className="border rounded p-3 bg-light "
                  style={{ height: "700px", overflowY: "auto" }}
                >
                  {customerList.length === 0 && mobile ? (
                    <div className="text-center text-muted fs-5 mt-5">
                      {orderType === "homedelivery" ? (
                        <div
                          className="container py-4 px-3"
                          style={{ maxWidth: 540 }}
                        >
                          <h3 className="mb-4 text-dark fw-semibold">
                            {" "}
                            Add New Customer
                          </h3>

                          {formErrors.api && (
                            <div className="alert alert-danger py-2 px-3 mb-3 rounded">
                              {formErrors.api}
                            </div>
                          )}

                          {formErrorsOrder.map((key) =>
                            formErrors[key] ? (
                              <div
                                key={key}
                                className="alert alert-danger py-2 px-3 mb-3 rounded"
                              >
                                {formErrors[key]}
                              </div>
                            ) : null
                          )}

                          <div className="row g-3">
                            <div className="col-12">
                              <input
                                type="text"
                                className="form-control p-3 shadow-sm"
                                placeholder="Full Name *"
                                value={newAddress.name}
                                onChange={(e) =>
                                  handleInputChange("name", e.target.value)
                                }
                              />
                            </div>



                            <div className="col-12">
                              <input
                                type="text"
                                className="form-control p-3 shadow-sm"
                                placeholder="Address *"
                                value={newAddress.address}
                                onChange={(e) => handleInputChange("address", e.target.value)}
                              />
                            </div>

                            <div className="col-12">
                              <input
                                type="text"
                                className="form-control p-3 shadow-sm"
                                placeholder="City *"
                                value={newAddress.city}
                                onChange={(e) =>
                                  handleInputChange("city", e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="d-flex justify-content-start mt-4">
                            <button
                              className="scale-button btn btn-success px-4 py-2 rounded-pill shadow-sm"
                              onClick={() =>
                                handleAddNewAddress({
                                  contact_name: newAddress.name,
                                  contact_number: mobile,
                                })
                              }
                            >
                              Save Address
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          {searchCustomerLoader ? (
                            <>
                              <div className="spinner-border text-secondary mt-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <div className="mt-3 fs-5 fw-medium">Loading Customer...</div>
                            </>
                          ) : (
                            <div className="mt-3 fs-5 fw-medium">No customer found.</div>
                          )}</>
                      )}
                    </div>
                  ) : (
                    customerList.map((item, index) => (
                      <div
                        key={item.id}
                        onClick={() => setSelectedCustomer(item)}
                        className={` w-100 p-3 my-2 cursor-pointer  
            ${item.id === selectedCustomer?.id
                            ? "card text-dark border border-success "
                            : "bg-light border  rounded"
                          }`}
                        style={{ transition: "0.3s ease", cursor: "pointer" }}
                      >
                        <div className="fs-5 fw-semibold d-flex justify-content-between align-items-center">
                          <span>
                            {item.contact_name} | {item.contact_number}
                          </span>
                          {orderType === "homedelivery" && (
                            <button
                              className="scale-button btn bg-green-order text-white single-line-css"
                              onClick={() => setShowAddressFormFor(item)}
                            >
                              Add Address
                            </button>
                          )}
                        </div>
                        {showAddressFormFor?.id === item.id && (
                          <div className="text-start my-3">
                            <h6 className="mb-3 text-dark">
                              Add Another Address for {item.name}
                            </h6>

                            {formErrors.api && (
                              <div className="alert alert-danger">
                                {formErrors.api}
                              </div>
                            )}
                            {formErrorsOrder.find((k) => formErrors[k]) &&
                              !formErrors.api && (
                                <div className="alert alert-warning">
                                  {
                                    formErrors[
                                    formErrorsOrder.find((k) => formErrors[k])
                                    ]
                                  }
                                </div>
                              )}

                            <div className="row g-3">
                              <div className="col-12">
                                <textarea
                                  placeholder="Full Address *"
                                  className="form-control p-3"
                                  rows="2"
                                  value={newAddress.address}
                                  onChange={(e) =>
                                    handleInputChange("address", e.target.value)
                                  }
                                />
                              </div>
                              <div className="col-12">
                                <input
                                  placeholder="Landmark / Area *"
                                  className="form-control p-3"
                                  value={newAddress.landmark_area}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "landmark_area",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                              <div className="col-12">
                                <input
                                  placeholder="City *"
                                  className="form-control p-3"
                                  value={newAddress.city}
                                  onChange={(e) =>
                                    handleInputChange("city", e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <button
                              className="scale-button btn btn-primary mt-4"
                              onClick={() =>
                                handleAddMoreAddress({
                                  contact_name: item.name,
                                  contact_number: item.mobile,
                                })
                              }
                            >
                              Save Address
                            </button>
                          </div>
                        )}

                        {orderType === "homedelivery" && (
                          <>
                            {/* Default Address Display */}
                            <div className="mt-3">
                              <div className="p-3 border rounded bg-light">
                                <span className="badge bg-green-order text-white me-2 fs-5">
                                  Default Address
                                </span>
                                <span className="fs-6 text-dark">
                                  {item.defaultAddress}
                                </span>
                              </div>
                            </div>
                            <hr />
                            {/* Address List */}
                            <div className="fs-6 mt-4">
                              {item.address.map((address, index) => {
                                const isDefault =
                                  address === item.defaultAddress;

                                return (
                                  <div
                                    key={index}
                                    className={`border rounded p-3 mb-3 ${isDefault
                                        ? "bg-success bg-opacity-10 border-success"
                                        : ""
                                      }`}
                                  >
                                    <div className="d-flex justify-content-between align-items-start flex-wrap">
                                      <div className="text-dark w-75">
                                        {address}
                                      </div>

                                      {!isDefault && (
                                        <button
                                          className="scale-button btn btn-sm btn-outline-success"
                                          onClick={() =>
                                            handleDefaultAddress(
                                              item.contact_number,
                                              address
                                            )
                                          }
                                        >
                                          Mark as Default
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* {editCustomer && (
  <>

    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
      style={{ zIndex: 1040 }}
      onClick={() => setEditCustomer(false)}
    />

  
    <div
      className="position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-4 rounded-4"
      style={{ width: "90%", maxWidth: "1000px", zIndex: 1050 }}
    >
      <div className="row m-0 p-0">
        <div className="col-12">
          <div className="text-center mb-4">
            <h4 className="fw-bold">Customer Details</h4>
          </div>

          <div className="d-flex flex-column align-items-start bg-light p-3 rounded-3 mb-3">
            <div className="d-flex align-items-center mb-2 w-100">
              <strong className="me-2">Name:</strong>
              <span>{selectedCustomer?.contact_name || "NA"}</span>
              <button
                className="scale-button btn btn-sm btn-outline-primary ms-auto"
                onClick={() => {
                  setNewName(selectedCustomer?.contact_name || "");
                  setEditingName(true);
                }}
              >
                {selectedCustomer?.contact_name ? "Edit Name" : "Add Name"}
              </button>
            </div>

            {editingName && (
              <div className="w-100">
                <div className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Customer Name"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                     onFocus={onFocus}
                  />
                </div>
                <div>
                  <button
                    className="btn btn-success me-2"
                    onClick={() => handleUpdateCustomerName(newName,selectedCustomer.contact_number)}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setEditingName(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <div className="mt-3">
              <strong>Mobile:</strong> {selectedCustomer.contact_number || "No Number"}
            </div>
          </div>

      

         
        </div>
      </div>
    </div>
  </>
)} */}





    </div>
  );
};

export default Items;
